import { render, staticRenderFns } from "./updTagRelationEditor.vue?vue&type=template&id=675f6a69&scoped=true"
import script from "./updTagRelationEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./updTagRelationEditor.vue?vue&type=script&setup=true&lang=js"
import style0 from "./updTagRelationEditor.vue?vue&type=style&index=0&id=675f6a69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675f6a69",
  null
  
)

export default component.exports